module.exports = __webpack_public_path__ + "static/media/26.36b1a1ee.jpg";